var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66667 4.66683C4.66667 2.82588 6.15905 1.3335 8 1.3335C9.84095 1.3335 11.3333 2.82588 11.3333 4.66683V6.66683H12C13.1046 6.66683 14 7.56226 14 8.66683V12.6668C14 13.7714 13.1046 14.6668 12 14.6668H4C2.89543 14.6668 2 13.7714 2 12.6668V8.66683C2 7.56226 2.89543 6.66683 4 6.66683H4.66667V4.66683ZM6 6.66683H10V4.66683C10 3.56226 9.10457 2.66683 8 2.66683C6.89543 2.66683 6 3.56226 6 4.66683V6.66683ZM4 8.00016C3.63181 8.00016 3.33333 8.29864 3.33333 8.66683V12.6668C3.33333 13.035 3.63181 13.3335 4 13.3335H12C12.3682 13.3335 12.6667 13.035 12.6667 12.6668V8.66683C12.6667 8.29864 12.3682 8.00016 12 8.00016H4ZM8 9.3335C8.36819 9.3335 8.66667 9.63197 8.66667 10.0002V11.3335C8.66667 11.7017 8.36819 12.0002 8 12.0002C7.63181 12.0002 7.33333 11.7017 7.33333 11.3335V10.0002C7.33333 9.63197 7.63181 9.3335 8 9.3335Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockClosed);
export default __webpack_public_path__ + "static/media/lock-closed.d81fa3ada6f41220c9f939ed29bb0bd6.svg";
export { ForwardRef as ReactComponent };